import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const NotFound = () => (
  <>
    <Helmet>
      <title>Page Not Found — Safe Edges</title>
      <meta name="robots" content="noindex, follow" />
    </Helmet>
    <div className="min-h-screen flex flex-col items-center justify-center bg-black text-white px-6 text-center">
      <p className="text-8xl font-bold text-teal-400 mb-4">404</p>
      <h1 className="text-3xl font-bold mb-3">Page Not Found</h1>
      <p className="text-gray-400 mb-8 max-w-md">
        This page doesn't exist or has moved. Try exploring our security services.
      </p>
      <div className="flex flex-wrap gap-4 justify-center">
        <Link
          to="/"
          className="px-8 py-3 rounded-xl bg-gradient-to-r from-teal-400 to-blue-500 text-black font-semibold hover:from-teal-500 hover:to-blue-600 transition-all"
        >
          Back to Home
        </Link>
        <Link
          to="/services"
          className="px-8 py-3 rounded-xl border border-white/20 text-white font-semibold hover:border-teal-400/60 hover:text-teal-300 transition-all"
        >
          View Services
        </Link>
      </div>
    </div>
  </>
);

export default NotFound;
